import { SET_PAYMENT_INFO } from '@/action-types/payment'
interface Action {
  type: string,
  payload: Object,
}
const initDepotState = {
  name: '',
  checkin_id: undefined,
}
const payment = (state: {} = initDepotState, action: Action) => {
  switch (action.type) {
    case SET_PAYMENT_INFO:
      return Object.assign({}, initDepotState, { ...action.payload })
    default:
      return state
  }
}
export { payment }
